import type {ChangeEvent, ChangeEventHandler, ReactNode} from "react";

type FormLabelProps = {
    htmlFor: string;
    children: ReactNode;
    required?: boolean;
};

function FormLabel({htmlFor, children, required = false}: FormLabelProps) {
    return (
        <label htmlFor={htmlFor} className={"form-label" + (required ? " required-custom" : "")}>
            {children}
        </label>
    );
}

function handleInputChange(e: ChangeEvent<HTMLInputElement>): void {
    e.currentTarget.classList.remove("is-invalid-focus");
}

type FieldProps = {
    name: string,
    label: ReactNode,
    required?: boolean,
    type?: string,
    value?: string,
    onChange?: ChangeEventHandler<HTMLInputElement>,
    placeholder?: string,
    readOnly?: boolean,
    noErrorChange?: boolean,
};

const today = new Date().toISOString().split('T')[0];

export function Field(
    {
        name,
        label,
        required = false,
        type = "text",
        value,
        onChange,
        placeholder,
        readOnly = false,
        noErrorChange = false,
    }: FieldProps) {
    return (
        <div className="signup_container">
            <FormLabel htmlFor={name} required={required}>
                {label}
            </FormLabel>
            <input
                type={type}
                name={name}
                value={value}
                onChange={(e)=> {
                    if (!noErrorChange) handleInputChange(e);
                    if (onChange) onChange(e);
                }}
                readOnly={readOnly}
                className="form-control custom-input"
                placeholder={placeholder}
                min={type == "date" ? "1900-01-01": undefined}
                max={type == "date" ? today: undefined}
                maxLength={type == "number" ? 13: undefined}
            />
        </div>
    );
}